import React from "react";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import differenceInDays from "date-fns/difference_in_days";
import differenceInYears from "date-fns/difference_in_years";
import format from "date-fns/format";

export default (function (content) {
  if (content.published_date) {
    if (differenceInYears(content.published_date, new Date()) <= -1) {
      // More than a year: "[3-letter month] [day], [year]"
      return format(content.published_date, "MMM D, YYYY");
    } else if (differenceInDays(content.published_date, new Date()) <= -1) {
      // More than a day but less than a year: "[3-letter month] [day]" (e.g. "Sep 5")
      return format(content.published_date, "MMM D");
    }
    // Less than an hour old: "[x] mins ago"
    // Less than a day but more than an hour: "[x] hrs ago"
    var distance = distanceInWordsStrict(new Date(), content.published_date, { addSuffix: true });
    return distance.replace("minute", "min");
  } else {
    if (content.status && content.status !== "published") {
      return React.createElement(
        "i",
        null,
        "unpublished"
      );
    } else {
      // Published items with a published date of null are a big no-no.
      // This maybe should even throw an error.
      return null;
    }
  }
});


// WEBPACK FOOTER //
// ./src/utils/formatPublishedDate.js